'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'loader';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e1d4';
var svgPathData = ['', 'M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8s8-3.6 8-8l0-80zm0 416c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 80c0 4.4 3.6 8 8 8s8-3.6 8-8l0-80zM86.3 75c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L86.3 75zM380.5 369.1c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L425.7 437c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-56.6-56.6zM0 256c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L8 248c-4.4 0-8 3.6-8 8zm416 0c0 4.4 3.6 8 8 8l80 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-80 0c-4.4 0-8 3.6-8 8zM75 425.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L75 425.7zM369.1 131.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L437 86.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-56.6 56.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLoader = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;